import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  lang: "en",
};

// Language Slice
export const languageSlice = createSlice({
  name: "lang",
  initialState,
  reducers: {
    setLang: (state, { payload }) => {
      state.lang = payload;
    },
  },
});

export default languageSlice.reducer;
export const { setLang } = languageSlice.actions;
